import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import NewVisitorDialog from "./NewVisitorDialog";

const VisitorsTable = ({
  dailyReport,
  setDailyReport,
  updateDailyReportMutation,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const hideDialog = () => {
    setIsVisible(false);
  };
  const header = () => {
    return (
      <div className="flex align-items-center justify-content-between gap-2">
        <span className="text-xl text-900 font-bold">Visitors</span>
        <Button
          className="w-9rem"
          label="Create"
          icon="pi pi-plus"
          onClick={() => {
            setIsVisible(true);
          }}
        />
      </div>
    );
  };

  const cellEditor = (options) => {
    if (options.field === "vendor_id") return textEditor(options);
    return textEditor(options);
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onCellEditComplete = (e) => {
    let { newRowData, newValue, field, originalEvent: event, rowIndex } = e;

    let shouldUpdated = dailyReport["visitors"][rowIndex][field] !== newValue;

    if (!shouldUpdated) {
      return;
    }

    let _dailyReport = { ...dailyReport };
    _dailyReport["visitors"][rowIndex][field] = newValue;
    setDailyReport(_dailyReport);

    let updatedData = { visitors: _dailyReport["visitors"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const handleRemoveRow = (rowIndex) => {
    let _dailyReport = { ...dailyReport };
    _dailyReport.visitors.splice(rowIndex, 1);
    setDailyReport(_dailyReport);

    let updatedData = { visitors: _dailyReport["visitors"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const actionBodyTemplate = (rowData, options) => {
    const { rowIndex } = options;
    return (
      <Button
        type="button"
        icon="pi pi-times"
        rounded
        severity="danger"
        onClick={() => handleRemoveRow(rowIndex)}
        text
      />
    );
  };

  return (
    <>
      <div className="card p-fluid">
        <DataTable
          value={dailyReport.visitors}
          editMode="cell"
          tableStyle={{ minWidth: "50rem" }}
          header={header}
        >
          <Column
            key="visitor_name"
            field="visitor_name"
            header="Visitor"
            style={{ width: "50%" }}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column
            key="visitor_note"
            field="visitor_note"
            header="Note"
            style={{ width: "50%" }}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column
            headerStyle={{ width: "5rem", textAlign: "center" }}
            bodyStyle={{ textAlign: "center", overflow: "visible" }}
            body={actionBodyTemplate}
          />
        </DataTable>
      </div>
      <NewVisitorDialog
        isVisible={isVisible}
        hideDialog={hideDialog}
        dailyReport={dailyReport}
        setDailyReport={setDailyReport}
      />
    </>
  );
};
export default VisitorsTable;
